/*
 * Single centered column for auth screens — no hero panel. The logo
 * left-aligns with the form content below it.
 */
import React from 'react'
import GpLogo from './GpLogo'

function GpAuthShell({ children }) {
    return (
        <div className="gp-auth-shell">
            <div className="gp-auth-shell-inner">
                <div style={{ marginBottom: 48 }}>
                    <GpLogo size={22} />
                </div>
                {children}
            </div>
        </div>
    )
}

export default GpAuthShell
